import React, { useEffect, useMemo, useState } from "react";
import styles from "./card.module.scss";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";

type Props = {
  title: React.ReactNode;
  hint: string;
  releaseDate: string;
  isActive: boolean;
  openCard?: () => void;
};

function HoverCard(props: Props) {
  const { title, hint, releaseDate, isActive, openCard } = props;

  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    setTimeout(() => setHovered(isActive), 50);
  }, [isActive]);

  const hoverStyles = useMemo(() => {
    const style = [styles.cardBack];
    if (hovered) {
      style.push(styles.fadeIn);
    } else {
      style.push(styles.fadeOut);
    }
    return style.join(" ");
  }, [hovered]);

  return (
    <div
      className={hoverStyles}
      style={{ display: isActive ? "flex" : "none" }}
      onClick={openCard}
    >
      <IconOutline className={styles.infoicon} width={36} height={36} />
      <div className={styles.hoverCardText}>
        <div className={styles.span1}>{title}</div>
        {hint && (
          <div className={styles.span2}>
            <strong>Hint: </strong>
            {hint}
          </div>
        )}
        {releaseDate && (
          <div className={styles.span2}>
            <strong>Release Date: </strong>
            {releaseDate}
          </div>
        )}
      </div>
    </div>
  );
}

export default HoverCard;
